import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NbDialogService } from "@nebular/theme";
import { NotificationsService } from "angular2-notifications";
import { NgxSpinnerService } from "ngx-spinner";
import { ImportarArquivoBaseComponent } from "../../../importacao-lote/abstract/importar-arquivo-base.component";
import { EColumnType } from "../../../importacao-lote/components/table/EColumnType";
import { EImportacaoType } from "../../../importacao-lote/components/table/EImportacaoType";
import { ILoteDetalhes } from "../../../importacao-lote/dto/ILoteDetalhes";
import cancelarImportacaoLote from "../../../importacao-lote/utils/cancelar-importacao";
import { HttpService } from "../../../services/http/http-client.service";
import { CommonService } from "../../../services/commom.service";
import { OrigemImportacaoService } from "../../../importacao-lote/utils/origem-importacao.service";

export interface IErrosType {
  id: number;
  loteId: number;
  nome: string;
  cpf: string;
  matricula: string;
  telefone: string;
  email: string;
  dataNascimento: string;
  status: string;
  motivoStatus: string;
  numeroLinha: number | null;
  dataCadastro: string;
  ultimaAtualizacao: string | null;
  nomeMae: string;
  codigoCentroDeCusto	: string;
}

@Component({
  selector: "ngx-importacao-arquivo-funcionario-lote",
  templateUrl: "./importar-arquivo-funcionario-lote.component.html",
  styleUrls: ["./importar-arquivo-funcionario-lote.component.scss"],
})
export class ImportarArquivoFuncionarioLoteComponent extends ImportarArquivoBaseComponent {
  public urlPost = "/importacao-funcionario";
  public EImportacaoType = EImportacaoType.FUNCIONARIO;
  public isProdutoMigrado = false;

  public errorTableColumns = [
    { prop: "", name: "", type: EColumnType.MODAL },
    { prop: "nome", name: "Nome", type: EColumnType.STRING },
    { prop: "cpf", name: "CPF", type: EColumnType.CPF_CNPJ },
    { prop: "matricula", name: "Matrícula", type: EColumnType.STRING },
    { prop: "email", name: "Email", type: EColumnType.STRING },
    { prop: "telefone", name: "Telefone", type: EColumnType.PHONE },
    { prop: "nomeMae", name: "Nome da mãe", type: EColumnType.STRING },
    { prop: "dataNascimento", name: "Nascimento", type: EColumnType.STRING },
    { prop: "codigoCentroDeCusto", name: "Centro de Custo", type: EColumnType.STRING },
  ];

  constructor(
    private router: Router,
    activatedRoute: ActivatedRoute,
    http: HttpService,
    notifications: NotificationsService,
    origemService: OrigemImportacaoService,
    public spinnerService: NgxSpinnerService,
    public dialogService: NbDialogService,
    private commonService: CommonService
  ) {
    super(http, notifications, activatedRoute, origemService);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.verificarMigracaoRollout();
  }

  private verificarMigracaoRollout(): void {
    this.commonService.isProdutoMigrado().subscribe(isMigrated => {
      this.isProdutoMigrado = isMigrated;
    });
  }

  getDados(): void {
    this.http.doGet(
      `/importacao-funcionario/${this.loteId}/detalhes-lote-funcionario`,
      "",
      (response: ILoteDetalhes) => {
        this.loteDetalhes = response;
        this.validateData(response);
      }
    );
  }

  handleImportSuccess(event): void {
    this.spinnerService.show();
    try {
      this.loteId = event.id;
      this.setUrlGet();
      this.getDados();
    } finally {
      this.spinnerService.hide();
    }
  }

  downloadErrorReport(): void {
    this.downloadErrorReportCall<IErrosType>(this.EImportacaoType);
  }

  continue() {
    this.router.navigate(["validar-importacao"], {
      relativeTo: this.activatedRoute.parent,
      queryParams: { loteId: this.loteId },
    });
  }

  cancel() {
    cancelarImportacaoLote(
      this.dialogService,
      this.spinnerService,
      this.notifications,
      this.router,
      this.http,
      this.loteDetalhes,
      this.EImportacaoType
    );
  }

  goToFinished(): void {
    this.router.navigate(["importacao-finalizada"], {
      relativeTo: this.activatedRoute.parent,
      queryParams: { loteId: this.loteId },
    });
  }

  setUrlGet() {
    this.urlGet = `/importacao-funcionario/${this.loteId}/itens-lote`;
  }

  setBreadcrumbPath(): void {
    this.breadcrumbPath = [
      {
        label: this.loteId
          ? `Lote ID ${this.loteId}`
          : "Cadastro de colaboradores",
        link: this.loteId ? null : `/pages/${this.router.url.split("/")[2]}/importacao-lote`,
      },
      { label: "Importação" },
    ];
  }
}
